import React from "react";
type FormFieldProps = {
  id: string;
  label: string;
  optional?: boolean;
  error?: string;
  hint?: React.ReactNode;
  children: React.ReactNode;
};
export function FormField({
  id,
  label,
  optional,
  error,
  hint,
  children
}: FormFieldProps) {
  return <div data-id="element-101" data-mp="2aaorpugmxjhq">
      <div className="mb-2 flex items-baseline justify-between" data-id="element-102" data-mp="25doixbsei2mx">
        <label htmlFor={id} className="text-[14px] font-semibold text-ink" data-id="element-103" data-mp="25c54lqqb21ns">
          {label}
        </label>
        {optional && <span className="text-[12px] text-stone" data-id="element-104" data-mp="2k8mba4njus40">Optional</span>}
        {hint && !optional && <span className="text-[12px] tabular-nums text-stone" data-id="element-105" data-mp="2f9rvlbkvpjo4">{hint}</span>}
      </div>
      {children}
      {error && <p id={`${id}-error`} role="alert" className="mt-2 text-[13px] font-medium text-accent" data-id="element-106" data-mp="2p1ntalj1z7rt">
          {error}
        </p>}
    </div>;
}
export const fieldClass = (hasError: boolean) => `block w-full rounded-lg border bg-white px-4 text-[16px] text-ink placeholder:text-stone/60 transition-[border-color,box-shadow] duration-150 focus:outline-none focus:ring-4 ${hasError ? "border-accent focus:ring-accent/15" : "border-line hover:border-ink/30 focus:border-ink focus:ring-ink/[0.06]"}`;